/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;



//////////////////
// WEBPACK FOOTER
// ../node_modules/webpack/buildin/amd-options.js
// module id = 59
// module chunks = 0